import { useEffect } from 'react';

export const useClickstreamAnalytics = () => {
    useEffect(() => {
        const asynchronouslyLoadAnalytics = async () => {
            const { initializeClickstream } = await import(
                /* webpackChunkName: "analytics" */
                '../initializeClickstream'
            );
            initializeClickstream();
        };
        asynchronouslyLoadAnalytics();
    }, []);
};
